import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoaderService } from '../services/loader.service';
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, CookieService, SessionStorageService } from '@collab/comp-library';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';


@Injectable({
    providedIn: 'root'
})

export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(public router: Router, public loaderService: LoaderService, private cookieService: CookieService, private localStorage: SessionStorageService ,  private authService : AuthService) {}

    public intercept(request: HttpRequest < any > , next: HttpHandler): Observable < HttpEvent < any >> {
        this.loaderService.show();
        return next.handle(request)
            .pipe(
                retry(request.url.includes('user/signin') ? 0 : 1),
                    finalize(() => this.loaderService.hide()),
                // TODO remove toastr
                // tap((event: HttpEvent<any>) => {
                //     finalize(() => this.loaderService.hide());
                //     if (event instanceof HttpResponse && event.status === 200) {
                //         this.toastr.success('Object created.');
                //     }
                // }),
                catchError((error) => {
                    let errorMessage = '';

                    if (error.status === 401) {
                        this.clearCahceAndRedirect();
                    } else if (error.error instanceof ErrorEvent) {
                        errorMessage = `Error: ${error.error.message}`;

                        if (!this.router.url.includes('/password-reset-page')) {
                            window.alert(errorMessage);
                        }

                        return throwError(error.error.message);
                    } else {
                        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;

                        if (!this.router.url.includes('/password-reset-page')) {
                            window.alert(errorMessage);
                        }

                        return throwError(error.error.message);
                    }
                    return Observable.throw(error.statusText);

                })
            );
      }

    private clearCahceAndRedirect() {
        this.cookieService.setCookie(ACCESS_TOKEN_KEY, '', 0);
        this.cookieService.setCookie(REFRESH_TOKEN_KEY, '', 0);
        this.localStorage.setStorage('userId', '');
        // window.location.href = environment.uiUrl + '/#/login?error=invalid_token';
        this.authService.logout();
    }
}
